export function formatCurrencyBRL(
  value: number,
  removeSymbol: boolean = false,
  forceDecimalSeparator?: ',' | '.',
  hideZeroCents: boolean = false
): string {
  let formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: hideZeroCents ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value)

  if (removeSymbol) {
    formatted = formatted.replace(/^R\$\s?/, '')
  }

  if (forceDecimalSeparator) {
    if (forceDecimalSeparator === '.') {
      formatted = formatted.replace(/,(\d{2})$/, '.$1')
    } else if (forceDecimalSeparator === ',') {
      formatted = formatted.replace(/.(\d{2})$/, ',$1')
    }
  }

  return formatted
}
